// Vendor imports
const { connect } = require('react-redux')
// Container imports
const AppNav = require('./component-dumb')

function mapStateToProps(state) {
  if (!state.user.loggedIn) {
    // Hide the nav bar for logged-out users
    return { hidden: true, items: [] }
  }
  // Determine selected state
  return {
    hidden: state.env.nativeEmbedded,
    items: NAV_ITEMS,
    selected: navSelectedState(state)
  }
}

module.exports = connect(
  mapStateToProps
)(
  AppNav
)

// Helpers

const NAV_ITEMS = [
  { title: 'For you', href: '/for-you' },
  { title: 'Following', href: '/following' },
  { title: 'Popular', href: '/popular' }
]

const HREF_ALIASES = {
  '/for-you': [
    '/',
    '/add',
    '/mixit',
    '/top-for-you'
  ],
  '/following': [
    '/recently-added'
  ],
  '/popular': [
    '/mix',
    '/interests',
    '/collections',
    '/people',
    '/explore',
    '/explore/interests',
    '/explore/collections',
    '/explore/people'
  ]
}

function navSelectedState(state) {
  const { pathname } = state.router.location
  let selected = null
  NAV_ITEMS.forEach(item => {
    const itemAliases = HREF_ALIASES[item.href]
    if (pathname === item.href || itemAliases.includes(pathname)) {
      selected = item.href
    }
  })
  return selected
}
